import { Notification } from "../redux/features/slices/notificationSlice";
import { notificationEndPoints } from "../constants/endpoints";
import { api } from "./api";
import { getApiOrganizationId } from "../utils/orgIdUtils";

export interface NotifyMeRequest {
  productId: string;
  productName: string;
  customerEmail: string;
}

export interface NotificationsResponse {
  notifications: Notification[];
  count: number;
}

export const notifyWhenInStockAPI = async (data: NotifyMeRequest) => {
  try {
    const customerId = localStorage.getItem("customerId");
    if (!customerId) {
      throw new Error("Customer ID not found");
    }

    const response = await api.post(notificationEndPoints.subscribeToRestock, {
      customerId,
      productId: data.productId,
      headers: {
        orgId: getApiOrganizationId(),
      },
    });

    const responseData = response.data?.body || response.data;
    const isAlreadySubscribed =
      responseData?.message?.toLowerCase().includes("already subscribed") ||
      responseData?.data?.message?.toLowerCase().includes("already subscribed");

    return {
      success: true,
      message: isAlreadySubscribed
        ? `You've already subscribed for notifications on ${data.productName}!`
        : `You'll be notified when ${data.productName} is back in stock!`,
      isAlreadySubscribed,
    };
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.body?.message ||
      error?.response?.data?.message ||
      "Failed to register for notifications";

    return {
      success: false,
      message: errorMessage,
      isAlreadySubscribed: false,
    };
  }
};

export const getNotificationsAPI = async (
  customerId: string
): Promise<NotificationsResponse> => {
  try {
    const response = await api.get(
      notificationEndPoints.getNotifications(customerId),
      {
        headers: {
          orgId: getApiOrganizationId(),
        },
      }
    );

    const notifications = response.data.data.rows;
    const count = response.data.data.count;

    const transformedNotifications = notifications.map((notification: any) => ({
      id: notification.id || `temp-${Date.now()}`,
      productId: notification.productId || notification.product_id || "",
      productName: notification.name || notification.productName || "Product",
      message: `Good news! ${notification.name || notification.productName || "Product"} is now back in stock!`,
      isRead: notification.isRead || notification.is_read || false,
      createdAt:
        notification.updatedAt ||
        notification.updated_at ||
        notification.createdAt ||
        notification.created_at ||
        new Date().toISOString(),
      type: notification.type,
    }));

    return {
      notifications: transformedNotifications,
      count,
    };
  } catch (error) {
    return {
      notifications: [],
      count: 0,
    };
  }
};

export const markNotificationAsReadAPI = async (notificationId: string) => {
  try {
    const response = await api.post(
      notificationEndPoints.markAsRead(notificationId),
      {},
      {
        headers: {
          orgId: getApiOrganizationId(),
        },
      }
    );
    const responseData = response.data?.body || response.data;
    return {
      success: responseData?.success !== false,
    };
  } catch (error) {
    return { success: false };
  }
};
